/**
 * 个人中心服务
 * created by chenhao 2017-12-5 10:35:43
 */
"use strict";
angular.module('zoneServiceModule', ['uploadHeaderModule', 'changeNumberModule'])
    .factory('zoneService', ["$modal","$q", function($modal,$q) {
        return {
            /**
             * [uploadHeader description] 上传头像
             * @return {[type]} [description]
             */
            uploadHeader: function(orginalHeader) {
                var modalInstance = $modal.open({
                    templateUrl: "./main/settings/modifyData/service/uploadHeader/uploadHeader_tpl.html",
                    windowClass: "uploadHeader",
                    backdrop: false,
                    controller: "uploadHeaderCtrl",
                    resolve: {
                        item: function() {
                            return {
                                url: orginalHeader.headpic,
                                rest:orginalHeader.headresp
                            };
                        }
                    }
                });

            },
            /**
             * [changeNumber description] 更换号码
             * @return {[type]} [description]
             */
            changeNumber: function(number) {
                var deffer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./main/settings/modifyData/service/changeNumber/changeNumber_tpl.html",
                    windowClass: "changeNumber",
                    backdrop: false,
                    controller: "changeNumberCtrl",
                    resolve: {
                        number: function() {
                            return number
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    deffer.resolve();
                });
                return deffer.promise;
            }
        };
    }]);
